import * as React from 'react'
import clsx from 'clsx'

export type Props = {
  selectorText: string
  totalOptionAmount: number | undefined
  currentlyChosenOption?: string
  className?: string
  onClick?: () => void
}

export const SelectorButton = ({
  selectorText,
  totalOptionAmount,
  currentlyChosenOption,
  className,
  onClick = () => {},
}: Props) => {
  return (
    <button
      onClick={onClick}
      className={clsx(
        'lg:transition-color flex w-full justify-between rounded-[5px] border border-grey-medium-3 bg-primary-white px-6 py-[9px] text-p hover:border-grey-dark-2 lg:py-3 lg:duration-300 lg:ease-out',
        className,
      )}
    >
      <span>
        {`${selectorText}`} <span className="text-p-small">{`(${totalOptionAmount ?? ''})`}</span>
      </span>
      <span className="font-medium">{currentlyChosenOption}</span>
    </button>
  )
}
